import { runInInjectionContext, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
type StepOptions = Shepherd.Step.StepOptions;
import { commonConfig } from './utils';

export function getHomeTourMobileSteps(injector: Injector): StepOptions[] {
  return runInInjectionContext(injector, () => {
    const router = inject(Router);

    return [
      {
        id: 'Home-mobile-step-01',
        title: 'Browse Your Subscriptions',
        text: 'Use this menu to explore your subscriptions by Pillar, Region or Document Type.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#HomeMobileStep1',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            if (router.url !== '/site') {
              router.navigate(['/site']).then(() => {
                setTimeout(() => {
                  resolve();
                }, 300);
              });
            } else {
              resolve();
            }
          });
        },
        ...commonConfig
      },
      {
        id: 'Home-mobile-step-02',
        title: 'View the Latest Publications',
        text: 'Here you’ll find the most recently published documents in your subscription.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#HomeStep2',
          on: 'top' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Home-mobile-step-03',
        title: 'Search Across All Content',
        text: 'Use keywords to search all documents and apply advanced filters to refine your results.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#HomeMobileStep3',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Advanced search',
            action() {
              window.open('/client/site/search-results', '_blank');
            }
          },
          {
            text: 'Finish',
            action() {
              this.complete();
              router.navigate(['/site/help']);
            }
          }
        ],
        ...commonConfig
      },
    ];
  });
}